import { Component, OnInit } from '@angular/core';
//import { AdataService } from '../../shared/adata.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Alert } from 'selenium-webdriver';
import Swal from 'sweetalert2';
import { UserService } from '../../shared/user.service';
import { DatePipe } from '@angular/common';
import swal from 'sweetalert2';

@Component({
  selector: 'app-pigmy-manualcollection',
  templateUrl: './pigmy-manualcollection.component.html',
  styleUrls: ['./pigmy-manualcollection.component.css']
})
export class PigmyManualcollectionComponent implements OnInit {
  title = "Pigmy Manual collection"
  data: any = {};
  formInvalid: boolean = false;
  commonUrl : string
  c: any = {};
  update:any={};
  g: any = {};
  t: any = {};
  b: any = {};
  s: any = {};
  p: any = {};
  Name:any;
  PigmyCollectionlist: any = [];
  mode: any;
  Account_Id: any;
  AccountCode: any;
  DepositorName:any;
  SubBranchCode:any;
  SchemeCode:any;
  BranchCode:any;
  Entry_Date:any;
  AccountTypeList: any
  PigmyBranchList: any
  PigmySubBranchList: any
  PigmySchemeList: any
  PigmyCollectionlistt: any = [];
  showhidenCkekbox: boolean;
  console: any;
  tot: any;
  myDate:any;
  totalamt:any=0;
  aNumber:number=0;
  Time:any={};
  PrsentCollectionList = [];
  TempTableList=[];
  temp:any={};
  Temp1:any={};
  PreAmount: any;
  userName : any;
  sumdo:any;
  showcollection:boolean=false;
  DateValues:string;

  logbranch:any;
  
  // mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";  

  constructor(private service: UserService,private datePipe: DatePipe) 
  { 
    this.commonUrl = service.rootUrl;
    this.userName = localStorage.getItem('userName');
  }

  ngOnInit() {
    this.logbranch=localStorage.getItem('BRANCH_ID');
    this.getAllACountTypeList()
    this.GetPigmyBranchList()
    this.getAllSchemeList()
    this.myDate =new Date();
    //this.c.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.c.myDate =this.datePipe.transform(this.myDate, 'dd-MM-yyyy');
    this.sumdo=0;
    this.showcollection=false;
    
  }
  getdatefun(indt:any)
  {
    debugger;
    this.DateValues=this.datePipe.transform(indt,'yyyy-MM-dd');
    return this.DateValues;
  }

  getAllACountTypeList() {

    debugger;
    this.data = this.service.AllACountType();
    this.data.subscribe(
      (response) => {
        this.AccountTypeList = response.AccountTypeModel;
        console.log('AccountTypeList');
        console.log(response);
      })
      this.c.AccountCode=3;
      this.loadgroup1(3);
  }

  GetPigmyBranchList() {
    debugger;
    this.data = this.service.getPigmyBranchList();
    this.data.subscribe(
      (response) => {
        this.PigmyBranchList = response.Pigmy_Branch;
        console.log('PigmyBranchList');
        console.log(response);
      })
      this.c.BranchCode=this.logbranch
  }
  loadgroup1(abbr) {
    debugger;
    console.log(abbr);
    this.data = this.service.getSubBranch(abbr);
    this.data.subscribe(
      (Response: any) => {
        this.PigmySubBranchList = Response.Result;
        console.log('BranchList')
        console.log(this.PigmySubBranchList);
      });
  }

  getAllSchemeList() {
    debugger;
    this.data = this.service.getAllSchemeType();
    this.data.subscribe(
      (response) => {
        this.PigmySchemeList = response.PigmySchemeModel;
        console.log('PigmySchemeList');
        console.log(response);
      })
  }
  SavePigmy(Pigmy: NgForm) {
    debugger;
    if(Pigmy.value.SchemeCode==undefined||null)
    {
      this.SchemeCodeempty=true;
    } 
    if(Pigmy.value.SubBranchCode==undefined||null)
        this.SubBranchCodeempty=true;
    if(Pigmy.value.Collection_date==undefined||null)
    {
      this.Collection_dateempty=true;
      Swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    }
    console.log(Pigmy.value);

    if (Pigmy.value.SchemeCode==undefined||null || Pigmy.value.SubBranchCode==undefined||null || Pigmy.value.Collection_date==undefined||null)
    {

      this.formInvalid = true;
      Swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }
    else {
      //Caste.value.Rlg_Id_FK= this.r.Rlg_Id;   

      // Pigmy.value.Entry_Date=this.datePipe.transform(this.myDate,'dd-MM-yyyy');
       Pigmy.value.Collection_date=this.datePipe.transform(this.c.Collection_date,'dd-MM-yyyy');
       debugger;
      this.data = this.service.PostPigmyManual(Pigmy.value);
      this.data.subscribe(
        (response) => {
          Pigmy.reset();
          Pigmy.resetForm();
          Pigmy.form.markAsPristine();
          Pigmy.form.markAsUntouched();
          //Swal.fire('Success!', 'Caste Added Successfully .', 'success');
          //this.router.navigate(['/CasteMasterCreationGrid/']) ;   
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401) {
            //this.errorHandler.HandlerError(error);
          }
          else if (error.status == 400) {
            Swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
  }

  SchemeCodeempty:boolean=false;
  SubBranchCodeempty:boolean=false;
  Collection_dateempty:boolean=false;

  SubBranchCodefilled()
  {
    this.SubBranchCodeempty=false;
  }


  getData(c:any,collect_dt:any) {
    debugger;
    if(c.SchemeCode==undefined||null)
      this.SchemeCodeempty=true;
    if(c.SubBranchCode==undefined||null)
        this.SubBranchCodeempty=true;
    if(c.Collection_date==undefined||null)
      this.Collection_dateempty=true;
    else 
      this.Collection_dateempty=false;
    //this.c.Collection_date=dat;

   // (<HTMLInputElement> document.getElementById("collectiondate")).disabled = true;

    this.myDate =new Date();
    var dte = new Date();
    dte.setDate(dte.getDate());
    this.Time.Date=dte.setDate(dte.getDate() - 1);
    var timedate=new Date(this.c.Collection_date);  //this.Time.Date;
     let entrydate=this.datePipe.transform(this.myDate, 'MM-dd-yyyy');
     let collectiondate=this.datePipe.transform(timedate, 'MM-dd-yyyy');

    this.data = this.service.GetallPigmylist(c.AccountCode,c.SubBranchCode,c.BranchCode,this.c.SchemeCode,entrydate,collectiondate);
   // this.data = this.service.GetallPigmylist(c.AccountCode,c.SubBranchCode,c.BranchCode,this.c.SchemeCode,c.myDate,c.Collection_date);
    this.data.subscribe(
      (response: any) => 
      {
        this.showcollection=true;
     this.PigmyCollectionlistt = response;
     let sum:any=0;
     let sum1:any=0;
     let prestcol:any=0;
   
     for(var i=0;i<this.PigmyCollectionlistt.length;i++)
     {
      

      if(this.PigmyCollectionlistt[i].Monthcol>0)
      {
        sum =sum + this.PigmyCollectionlistt[i].Monthcol;
        this.PigmyCollectionlistt[i].totalamt=this.PigmyCollectionlistt[i].Monthcol+this.PigmyCollectionlistt[i].coll_amt;
        
        
      }
      

      if(this.PigmyCollectionlistt[i].coll_amt>=0)
      {
        this.c.sum1 =sum1 + this.PigmyCollectionlistt[i].coll_amt;
       
      }
      if(this.PigmyCollectionlistt[i].prestcol>=0)
      {
        //
        this.g.prestcol =prestcol + this.PigmyCollectionlistt[i].prestcol;
       
      }

      if(this.PigmyCollectionlistt[i].totalamt>=0)
      {
         
         this.totalamt =this.totalamt + this.PigmyCollectionlistt[i].totalamt;
        
      }
      
     }
     this.c.sum=sum;
     this.c.My_Total_Blc=this.totalamt;
     console.log(this.c.My_Total_Blc)

    // for(var i=0;i<this.PigmyCollectionlistt.length;i++)
    // {
    //   if(this.PigmyCollectionlistt[i].totalamt>=0)
    //   {
    //     var aNumber : number = parseInt(entryAmount); 
    //     this.tot=colamt + aNumber ;
    //     this.PigmyCollectionlistt[i].totalamt=this.tot;
    //     this.c.Total=this.tot;
    //     console.log(this.g.totalamt);

    //   }
    // }
        //document.getElementById('loader-spinner').style.display = "none";
      },

      (error) => {
        //document.getElementById('loader-spinner').style.display = "none";
      }
    );
  }

  ChangeAjentName(id:any)
  {
    debugger;
    this.SchemeCodeempty=false;
    //return this.PigmySchemeList.filter(x => x.id === id);
    for(var i=0;i<this.PigmySchemeList.length;i++)
    {
      if(this.PigmySchemeList[i].SchemeCode==id)
      {
      this.c.Scheme_Name=this.PigmySchemeList[i].Scheme_Name;
      console.log(this.c.Scheme_Name);
      }
    }
    
  }
  SerchDepositor(AccountID:any,DepositorName:any)
  {
    debugger;
    let AccountNo:string=AccountID.trim();

    for(let i=0;i<this.PigmyCollectionlistt.length;i++)
    {
        
        if(this.PigmyCollectionlistt[i].AccountCode==AccountNo)
        {


          setTimeout(()=>{ // this will make the execution after the above boolean has changed
            this.PigmyCollectionlistt[i].highlight='Y';
            this.PigmyCollectionlistt[i].focus();
          },0);
          // this.PigmyCollectionlistt[i].highlight='Y';
        }
        
        // if(this.PigmyCollectionlistt[i].AccountCode==AccountID && this.PigmyCollectionlistt[i].DName==DepositorName)
        // {
        //   this.PigmyCollectionlistt[i].highlight='Y';
        // }

        // if(this.PigmyCollectionlistt[i].AccountCode!=AccountID && this.PigmyCollectionlistt[i].DName!=DepositorName)
        // {
        //   this.PigmyCollectionlistt[i].highlight='N'; g.Account_Id,c.SchemeCode,c.AccountCod
        // } 
       }
        
    
  }
  showSearch(){
     
  }

  getDatee()
  {
    debugger;
    var dte = new Date();
    dte.setDate(dte.getDate());
    this.Time.Date=dte.setDate(dte.getDate() - 1);
    //this.c.Collection_date=this.Time.Date;
    //date format
    this.c.Collection_date =this.getdatefun(this.Time.Date);
    // this.datePipe.transform(this.Time.Date, 'dd-MM-yyyy');
    //this.c.Collection_date = this.datePipe.transform(this.c.Collection_date, 'MM-dd-yyyy');
    console.log(this.c.Collection_date,'collection date');
    console.log(dte.toString());
  }
  

   Cancel()
   {
     debugger;
     this.c.AccountNumbe=''; 
     this.c.DepositorName='';
     for(let i=0;i<this.PigmyCollectionlistt.length;i++)
     {
        
         this.PigmyCollectionlistt[i].highlight='';
        
        // if(this.PigmyCollectionlistt[i].AccountCode==AccountID && this.PigmyCollectionlistt[i].DName==DepositorName)
        // {
        //   this.PigmyCollectionlistt[i].highlight='Y';
        // }

        // if(this.PigmyCollectionlistt[i].AccountCode!=AccountID && this.PigmyCollectionlistt[i].DName!=DepositorName)
        // {
        //   this.PigmyCollectionlistt[i].highlight='N'; g.Account_Id,c.SchemeCode,c.AccountCod
        // }
     }
 
   }
 
   RemoveData()
   {
     debugger;
     this.c.AccountCode='';
     this.c.SubBranchCode='';
     this.c.BranchCode='';
     this.c.SchemeCode='';
     this.c.Collection_date='';
     this.g.prestcol='';
     this.g.Name='';
     this.g.DepositorNameEntery='';
     this.PigmyCollectionlistt=[];
     this.c.sum1='';
     this.c.sum='';
     this.c.My_Total_Blc='';
     this.c.DepositorName='';
     this.c.TotalSum='';
     this.showcollection=false;
   }

   GetDepositorName(AccountNumbe:any)
   {
       debugger;
    let AccountNo:string=AccountNumbe.trim();
    for(var i=0;i<this.PigmyCollectionlistt.length;i++)
    {
      if(this.PigmyCollectionlistt[i].AccountCode==AccountNo)
      {
        
        this.c.DepositorName=this.PigmyCollectionlistt[i].Dname;

      }
    }
   }

   PrintData(){
    window.open(this.commonUrl+'/Reports/PigmyManulaCo/PigmyManualcol.aspx?userName='+this.userName);
   }

   Collection_datefilled()
   {
     this.Collection_dateempty=false;
     if(this.c.Collection_date.length>10)
     {
       this.c.Collection_date="";
       swal('Date','Date not correct','warning');
     }
   }



   sendvalue(dvalue: any, entryAmount: any, colamt: any, Dname: any, Account_Id: any, SchemeCode: any, MODID: any, Account_Mod: any, LastAmount: any, TotalCollection:any,sumoftot:any) {
    debugger;
  

    this.g.Name = dvalue;
    this.g.prestcol = entryAmount;
    //this.g.prestcol=colamt;

    this.g.Monthcol = colamt;
    this.g.DepositorNameEntery = Dname;
    this.c.AccountNumber = dvalue;
    this.c.Account_Id = Account_Id;
    let TotalSum: number = 0;
    

    for (var i = 0; i < this.PigmyCollectionlistt.length; i++) {
      if (this.PigmyCollectionlistt[i].AccountCode == dvalue) {
        this.tot=0;
        this.aNumber = parseInt(entryAmount);
        this.tot = (+colamt) + (+this.aNumber)+(+this.PigmyCollectionlistt[i].coll_amt);
        this.PigmyCollectionlistt[i].totalamt = this.tot;
        this.c.Total = this.tot;
        console.log(this.g.totalamt);
        this.temp={
          Prsent_Amt:entryAmount,
          Account_Id:Account_Id,
          Total:this.PigmyCollectionlistt[i].totalamt
        }
        this.PrsentCollectionList.push(this.temp);
      }
 
      if (this.PigmyCollectionlistt[i].totalamt >= 0) {
        TotalSum = TotalSum + this.PigmyCollectionlistt[i].totalamt;

        if (this.PigmyCollectionlistt[i].AccountCode == dvalue) {
          this.tot=0;
          this.g.prestcolsum=0;
          this.sumdo=0
        }
      }

      if (this.PigmyCollectionlistt[i].prestcol >= 0) {


      }



      this.c.My_Total_Blc = this.totalamt;
      this.c.TotalCollection = this.tot;
      this.c.My_Total_Blc = TotalSum;

    }
    this.PreAmount = this.PreAmount + parseInt(this.g.prestcol);
    this.c.PreAmount = this.PreAmount;

    this.c.MyAcoountNumber = this.g.Name;
    this.c.My_Total_Blc = this.tot;
    this.c.My_Total_Blc = TotalSum;
    debugger;
      if(sumoftot==null)
        sumoftot=0;

         // this.sumtot(entryAmount,sumoftot);

    
         if(this.sumdo==null)
         {
           this.sumdo=0;
         }
         this.sumdo=0;
         for (var i = 0; i < this.PigmyCollectionlistt.length; i++) {
           //console.log(this.PigmyCollectionlistt)
          //if (this.PigmyCollectionlistt[i].AccountCode == dvalue) {
              
              this.sumdo=(+this.PigmyCollectionlistt[i].prestcol)+(+this.sumdo);
            
            //this.sumdo=this.sumdo-this.PigmyCollectionlistt[i].prestcol;
            // this.tot=0;
            // this.g.prestcolsum=0;
            // this.sumdo=0
           // this.sumdo=(+entryAmount)+(+this.sumdo);
          }
       
        
         //this.sumtot(entryAmount,sumoftot);
          //this.sumdo=(+entryAmount)+(+this.sumdo);   
         this.g.prestcolsum=this.sumdo;
  }

sendData(AccountCode: any, totalamt: any, Account_Id: any, SchemeCode: any, MODID: any, prestcol: any, Entry_Date: any, Collection_date: any,BranchCode:any) {
    debugger;
    if(this.c.SchemeCode==undefined||null)
    this.SchemeCodeempty=true;
  if(this.c.SubBranchCode==undefined||null)
      this.SubBranchCodeempty=true;
  if(this.c.Collection_date==undefined||null)
    this.Collection_dateempty=true;
 if(this.c.SchemeCode==undefined||null || this.c.SubBranchCode==undefined||null || this.c.Collection_date==undefined||null)
 {
   swal('Mandatory','Fill all the ma ndatory fields','warning');
 }
 else
 {


    document.getElementById('loader-spinner').style.display = "block";

    this.c = {SchemeCode, MODID, prestcol, Entry_Date, Collection_date ,BranchCode};
    console.log(this.c);
    this.c.PresentCollection_Amount = this.PrsentCollectionList;
    for (var i = 0; i < this.PigmyCollectionlistt.length; i++) {  
        this.Temp1={
          Desposit_No:this.PigmyCollectionlistt[i].AccountCode,
          AMOUNT:this.PigmyCollectionlistt[i].prestcol
        }
        this.TempTableList.push(this.Temp1);
        this.c.TempModel = this.TempTableList;
        console.log("Testing",this.c.TempModel )
      }
console.log(Entry_Date);
debugger;



      var dte = new Date();
      dte.setDate(dte.getDate());
      this.Time.Date=dte.setDate(dte.getDate() - 1);
     // this.c.Collection_date=this.Time.Date;
      //date format
      let collda = this.datePipe.transform(this.Time.Date, 'MM-dd-yyyy');
      // this.c.Collection_date=collda
      this.c.Entry_Date=this.datePipe.transform(this.myDate,'MM-dd-yyyy');

      console.log(this.c.Collection_date);

//this.c.Collection_date=this.datePipe.transform(Collection_date,'dd-MM-yyyy');      
//this.c.Entry_Date=this.datePipe.transform(Entry_Date,'dd-MM-yyyy');
      console.log(this.c.Entry_Date);
      

    this.data = this.service.PostPigmyManual(this.c);
    this.data.subscribe(
      (response: any) => {
        this.c={};
        this.g={};
        this.PigmyCollectionlistt=[];
        Swal('Success!', 'Transactions Added Successfully .', 'success');
        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        //document.getElementById('loader-spinner').style.display = "none";
      }
    );
 }
    
  }
  sumtot(obj,sum)
  {
    debugger;
    if(this.sumdo==null)
    {
      this.sumdo=0;
    }
     this.sumdo=(+obj)+(+this.sumdo);   
    this.g.prestcolsum=this.sumdo;
  }

  checkdecimal(val,ind)
  {
    debugger;

    var chkdnum=val.replace(/[^0-9]/g, "");
    this.g.prestcol=chkdnum;
    let i=ind;
      this.PigmyCollectionlistt[ind].prestcol=chkdnum;
    
  
  }

  }






// WEBPACK FOOTER //
// ./src/app/general-transaction/pigmy-manualcollection/pigmy-manualcollection.component.ts